﻿import { Kb3dModel } from '../decorators/kb3d-decorator';
import { ISpotLightNode } from '../kb3d-models';
import { KbVector } from '../primitives/kb-vector';
import { Token } from '../token';
import { DirectionalLightNode } from './directional-light-node';

@Kb3dModel({
    token: Token.SpotLightNode,
})
export class SpotLightNode extends DirectionalLightNode implements ISpotLightNode {
    constructor() {
        super();
    }

    public position: KbVector;
    public coneAngle: number;
}
